const overview = (store, ref_no) => `/apps/${store}/${ref_no}/overview`;
const performance = (store, ref_no) => `/apps/${store}/${ref_no}/performance`;
const ranks = (store, ref_no) => `/apps/${store}/${ref_no}/rank_history`;
const organicKeywords = (store, ref_no) => `/search-analysis/organic_keywords/${store}/${ref_no}`;
const sentiments = (store, ref_no) => `/review-analysis/sentiments/${store}/${ref_no}`;
const sdks = (store, ref_no) => `/apps/${store}/${ref_no}/sdks`;
const xray = (store, ref_no) => `/x-ray/app_analysis/${store}/${ref_no}`;

export default {
  overview,
  performance,
  ranks,
  organicKeywords,
  sentiments,
  sdks,
  xray,
};
